<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div class="panel panel-default panel-stretch">
        <div class="panel-heading">
          {{ staticSearch.name }}
        </div>
        <div class="panel-body">
          {{ staticSearch.description }}
        </div>

        <a-f-d-message-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.AFD_MESSAGE"
            :static-search="staticSearch"/>
        <customer-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.CUSTOMER"
            :static-search="staticSearch"/>
        <damage-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.DAMAGE"
            :static-search="staticSearch"/>
        <email-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.EMAIL"
            :static-search="staticSearch"/>
        <mortgage-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.MORTGAGE"
            :static-search="staticSearch"/>
        <policy-overview-component
            v-if="staticSearch.model === StaticSearchModelEnum.POLICY"
            :static-search="staticSearch"/>

      </div>
    </div>
  </div>
</template>

<script>
import CustomerOverviewComponent from "./customer/OverviewComponent";
import DamageOverviewComponent from "./damage/OverviewComponent";
import EmailOverviewComponent from "./email/OverviewComponent";
import AFDMessageOverviewComponent from "./afd_message/OverviewComponent";
import MortgageOverviewComponent from "./mortgage/OverviewComponent";
import PolicyOverviewComponent from "./policy/OverviewComponent";
import staticSearchApi from '~/api/staticSearch';
import StaticSearchModelEnum from '~/enums/StaticSearchModelEnum';

export default ({
  name: "SelectionOverviewComponent",
  components: {
    CustomerOverviewComponent,
    DamageOverviewComponent,
    EmailOverviewComponent,
    AFDMessageOverviewComponent,
    MortgageOverviewComponent,
    PolicyOverviewComponent
  },
  props: {
    staticSearchIdHash: {
      type: String,
      required: true
    },
    routeParameters: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      staticSearch: {},
      StaticSearchModelEnum,
    }
  },
  mounted() {
    staticSearchApi.getStaticSearch(this.staticSearchIdHash, JSON.parse(this.routeParameters)).then(response => {
      this.staticSearch = response.data;
    })
  },
})
</script>